/*
Extrusion Pulls
  --length | length of the pieces that are ordered
*/
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'
import { length } from '@/modules/standardItems/schemas/baseFormFields'

export default [
  ...hardwareFormFields,
  length({ classes: ['xs12', 'sm4'] })
]
